export default __webpack_public_path__ + "static/media/bg_gif.0954e844.gif";